import { createContext } from "react";

import noop from "lodash/noop";

import { RegalAuthContextValue } from "App/main/RegalAuthContext";

import type { NullOr } from "@regal-voice/shared-types";
import type { Brand } from "Types/Brand";

export type LegacyUser = Pick<RegalAuthContextValue["user"], "email" | "firstName" | "lastName" | "name" | "roles">;

export type UserContextValue = {
    user: NullOr<LegacyUser>;
    isAdmin: boolean;
    brand: NullOr<Brand>;
    reloadBrand: () => void;
};

export const UserContext = createContext<UserContextValue>({
    user: null,
    brand: null,
    reloadBrand: noop,
    isAdmin: false,
});
